import { NotificationType } from '@/utils/enums'

export interface TextHighlight {
  length: number
  offset: number
}
export interface NotificationAuthor {
  _id: string
  picture: string
  social: boolean
}

export interface NotificationReference {
  _id: string
  name?: string
}

export interface NotificationBase {
  _id: string
  hidden: boolean
  read: boolean
  author: NotificationAuthor
  title: string
  createdAt: string
  highlights: TextHighlight[]
}

export interface NotificationGeneral extends NotificationBase {
  type: NotificationType.GENERAL
  body: string
  screen: string
  header: string
}

export const notificationTripRelatedTypes = [
  NotificationType.REMOVED_HIGHLIGHT,
  NotificationType.REMOVED_WAYPOINT,
  NotificationType.INVITED_ATTENDEE_YOU,
] as const

export type NotificationTripRelatedType =
  (typeof notificationTripRelatedTypes)[number]

export interface NotificationTripRelated extends NotificationBase {
  tripId: string
  type: NotificationTripRelatedType
}

export const notificationTripAndReferenceRelatedTypes = [
  NotificationType.ADDED_NOTE_TO_HIGHLIGHT,
  NotificationType.ADDED_NOTE_TO_WAYPOINT,
  NotificationType.ADDED_NOTE,
  NotificationType.ADDED_HIGHLIGHT,
  NotificationType.ADDED_WAYPOINT,
  NotificationType.ADDED_DOCUMENT,
  NotificationType.ADDED_EXPENSE,
] as const

export type NotificationTripAndReferenceRelatedType =
  (typeof notificationTripAndReferenceRelatedTypes)[number]

export interface NotificationTripAndReferenceRelated extends NotificationBase {
  tripId: string
  reference: NotificationReference
  type: NotificationTripAndReferenceRelatedType
}

export interface NotificationWebviewAction extends NotificationBase {
  type: NotificationType.WEBVIEW_ACTION
  header: string
  body: string
  userInfo: {
    webViewURL: string
    webViewLocalizedTitle: string
    campaign?: string
    category: 'WEBVIEW_ACTION'
  }
}

export type Notification =
  | NotificationGeneral
  | NotificationTripRelated
  | NotificationTripAndReferenceRelated
  | NotificationWebviewAction

// Type guard helper functions
export function isTripRelatedNotification(
  notification: Notification,
): notification is
  | NotificationTripRelated
  | NotificationTripAndReferenceRelated {
  return (
    (
      notificationTripAndReferenceRelatedTypes as readonly NotificationType[]
    ).includes(notification.type) ||
    (notificationTripRelatedTypes as readonly NotificationType[]).includes(
      notification.type,
    )
  )
}

export function isTripAndReferenceRelatedNotification(
  notification: Notification,
): notification is NotificationTripAndReferenceRelated {
  return (
    notificationTripAndReferenceRelatedTypes as readonly NotificationType[]
  ).includes(notification.type)
}
